import { render, staticRenderFns } from "./modalRejectWithReason.vue?vue&type=template&id=16bba9d8&scoped=true"
import script from "./modalRejectWithReason.vue?vue&type=script&lang=js"
export * from "./modalRejectWithReason.vue?vue&type=script&lang=js"
import style0 from "./modalRejectWithReason.vue?vue&type=style&index=0&id=16bba9d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16bba9d8",
  null
  
)

export default component.exports